import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TransfersEntity } from '../payments/DirectPayments/models/transfer';

type TransferState = {
  loading: boolean;
  error?: string;
  data?: TransfersEntity;
};

const initialState: TransferState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const transferSlice = createSlice({
  name: 'transfer',
  initialState,
  reducers: {
    /* Create transfer method handlers */
    createTransferStart: (state) => {
      state.loading = true;
    },
    createTransferSuccess: (state, action: PayloadAction<TransfersEntity>) => {
      state.loading = false;
      state.data = action.payload;
    },
    createTransferFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    /* Transfer poller method handlers */
    fetchTransferStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    fetchTransferSuccess: (state, action: PayloadAction<TransfersEntity>) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchTransferFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    /* Transfer reset method handler */
    resetTransfer: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
});

export const {
  createTransferStart,
  createTransferSuccess,
  createTransferFailure,
  resetTransfer,
  fetchTransferFailure,
  fetchTransferStart,
  fetchTransferSuccess,
} = transferSlice.actions;
